:host {
  --cta-link-mb: 10px;
  display: flex;
  flex-wrap: wrap;
}
:host(.center) {
  justify-content: center;
}
::slotted(igws-cta) {
  padding: 0 10px;
}

:host(.mobile) ::slotted(igws-cta){
  width: 100%;
  padding-left: 0;
}

:host(.arrow--light),
:host(.arrow--dark) {
  ::slotted(igws-cta) {
    --cta-link-text-height: 9px;
    --cta-link-text-margin: 0 0 0 7px;
    padding: 0 10px 0 0;
  }
}

:host(.arrow--light) {
  ::slotted(igws-cta) {
    --cta-arrow: @cta-arrow-light;
  }
}

:host(.arrow--dark) {
  ::slotted(igws-cta) {
    --cta-arrow: @cta-arrow-dark;
  }
}

/* tablet breakpoint */
@media (max-width: @medium-breakpoint) {
  :host {
    --cta-link-mb: 20px;
  }
  ::slotted(igws-cta) {
    width: 100%;
    padding-left: 0;
  }
}
